/* eslint-disable no-bitwise, no-console, no-unused-vars, class-methods-use-this, no-restricted-syntax, import/prefer-default-export */
let deviceActive;
const allDevices = [];
let deviceOpening = false;

let callStatus = {
  callActive: false,
  muteStatus: false,
  holdStatus: false,
};

class YealinkDevice {
  constructor(device, deviceId) {
    this.device = device;
    this.deviceId = deviceId;
    this.productName = device.productName;
    this.name = device.productName;

    // Bind the handler first
    this.boundHandler = this.handleInputReport.bind(this);

    // Set the input report handler using both methods for compatibility
    this.device.oninputreport = this.boundHandler;
    this.device.addEventListener('inputreport', this.boundHandler);

    console.log('YealinkDevice constructor - set oninputreport handler for:', this.productName); //eslint-disable-line
    console.log('YealinkDevice constructor - device.opened:', this.device.opened); //eslint-disable-line
  }

  open() {
    return this.device.open();
  }

  sendReport(value) {
    this.device.sendReport(2, value);
    console.log('device report id is', this.reportId);
  }

  sendMessage(data) {
    console.log('YealinkDevice.sendMessage - sending:', data); //eslint-disable-line
    window.postMessage({
      direction: 'yealink-headset-extension-from-web-hid',
      Msg: data,
    });
  }

  setDeviceId(deviceId) {
    this.deviceId = deviceId;
  }

  setReportId(reportId) {
    // Store multiple reportIds in an array
    if (!this.reportIds) {
      this.reportIds = [];
    }
    if (!this.reportIds.includes(reportId)) {
      this.reportIds.push(reportId);
    }
    // Keep legacy property for backwards compatibility
    this.reportId = reportId;
  }

  handleInputReport(event) {
    console.log('handleInputReport CALLED - event:', event); //eslint-disable-line
    const { data, device, reportId } = event;
    console.log(`handleInputReport - reportId: ${reportId}, valid reportIds: ${this.reportIds}`); //eslint-disable-line

    // Only process events from reportIds we've registered during device setup
    if (!this.reportIds || !this.reportIds.includes(reportId)) {
      console.log('handleInputReport - reportId not registered, ignoring'); //eslint-disable-line
      return;
    }

    const input = data.getUint8(0);
    console.log(`User pressed button ${input}, reportId=`, reportId);

    if (input === 0) {
      if (!callStatus.callActive) return;
      this.sendMessage('onHook');
    } else if (input === 2) {
      // Exact match for button 2 only - answer or hang up based on call state
      // Don't use bitwise to avoid matching button 3 (which is 2+1)
      if (!callStatus.callActive) {
        this.sendMessage('offHook');
      } else {
        this.sendMessage('onHook');
      }
    } else if ((4 & input) === 4) {
      if (!callStatus.callActive) return;
      if (callStatus.muteStatus) {
        this.sendMessage('Unmute');
      } else {
        this.sendMessage('Mute');
      }
    } else if ((8 & input) === 8) {
      if (!callStatus.callActive) return;
      if (callStatus.holdStatus) {
        this.sendMessage('Resume');
      } else {
        this.sendMessage('Hold');
      }
    } else if ((16 & input) === 16) {
      // Redial should work regardless of call status
      console.log('Yealink SDK: Redial button pressed, sending message');
      window.postMessage({
        type: 'YEALINK_REDIAL',
        source: 'yealink-headset',
      }, '*');
    } else if ((64 & input) === 64) {
      // Button 64 is the main call button on some Yealink models
      // Answer incoming calls or hang up active calls
      if (!callStatus.callActive) {
        this.sendMessage('offHook');
      } else {
        this.sendMessage('onHook');
      }
    }
  }
}

function addDevice(device) {
  console.log('[YealinkSDK addDevice] Called for:', device.productName);
  console.log('[YealinkSDK addDevice] Device collections:', device.collections?.length);

  let foundMatchingCollection = false;
  for (const collection of device.collections) {
    console.log('[YealinkSDK addDevice] Checking collection - usage:', collection.usage, 'usagePage:', collection.usagePage);
    if ((collection.usage === 0x0005 && collection.usagePage === 0x000B)) {
      foundMatchingCollection = true;
      console.log('[YealinkSDK addDevice] Found matching collection, creating YealinkDevice');
      const hidDevice = new YealinkDevice(device, '0');
      for (const inputReport of collection.inputReports) {
        const { reportId } = inputReport;
        console.log('[YealinkSDK addDevice] Setting reportId:', reportId);
        hidDevice.setReportId(reportId);
      }

      allDevices.push(hidDevice);
      console.log('[YealinkSDK addDevice] Device added to allDevices, count:', allDevices.length);

      window.postMessage({
        direction: 'yealink-headset-extension-from-web-hid',
        Msg: 'deviceConnect',
        productName: device.productName,
        name: device.productName,
        vid: device.vendorId,
        pid: device.productId,
      });
      break;
    }
  }

  if (!foundMatchingCollection) {
    console.log('[YealinkSDK addDevice] No matching collection found for device:', device.productName);
  }
}

// Export addDevice for direct use during pairing
export { addDevice };

export const yealink = {
  getDevices: navigator.hid.getDevices().then((devices) => {
    if (devices.length === 0) {
      console.log('No HID devices selected.');
      return;
    }

    devices.forEach((dev) => {
      // Only add Yealink devices (vendorId 0x6993 = 27027)
      if (dev.productName !== 'HID debug interface' && dev.vendorId === 0x6993) {
        console.log('Adding Yealink device on init:', dev.productName);
        addDevice(dev);
      }
    });
  }),

  ringoff() {
    this.sendToDevice(0);
    console.log(`"${deviceActive?.productName}" ring off`);
    return true;
  },

  ring() {
    this.sendToDevice(4);
    console.log(`"${deviceActive?.productName}" ring`);
    return true;
  },

  offHook() {
    if (callStatus.callActive) {
      console.log(`"${deviceActive?.productName}" already in calling`);
      return false;
    }

    this.sendToDevice(1);
    callStatus.callActive = true;
    console.log(`"${deviceActive?.productName}" off hook`);
    return true;
  },

  onHook() {
    if (!callStatus.callActive) {
      console.log(`"${deviceActive?.productName}" no call`);
      return false;
    }

    const muteStatus = callStatus.muteStatus ? 1 : 0;
    this.sendToDevice(0 | (muteStatus << 1));

    callStatus.callActive = false;
    callStatus.holdStatus = false;
    callStatus.muteStatus = false;
    console.log(`"${deviceActive?.productName}" on hook`);
    return true;
  },

  mute(force = false) {
    if (!callStatus.callActive || (callStatus.muteStatus && !force)) {
      console.log(`"${deviceActive?.productName}" no call or already mute`);
      return false;
    }

    this.sendToDevice(3);
    callStatus.muteStatus = true;
    console.log(`"${deviceActive?.productName}" mute`);
    return true;
  },

  unmute(force = false) {
    if (!callStatus.callActive || (!callStatus.muteStatus && !force)) {
      console.log(`"${deviceActive?.productName}" no call or already unmute`);
      return false;
    }

    this.sendToDevice(1);
    callStatus.muteStatus = false;
    console.log(`"${deviceActive?.productName}" unmute`);
    return true;
  },

  hold(force = false) {
    if (!callStatus.callActive || (callStatus.holdStatus && !force)) {
      console.log(`"${deviceActive?.productName}" no call or already hold`);
      return false;
    }

    const muteStatus = callStatus.muteStatus ? 1 : 0;
    this.sendToDevice(8 | (muteStatus << 1));
    callStatus.holdStatus = true;
    console.log(`"${deviceActive?.productName}" hold`);
    return true;
  },

  resume(force = false) {
    if (!callStatus.callActive || (!callStatus.holdStatus && !force)) {
      console.log(`"${deviceActive?.productName}" no call or no hold`);
      return false;
    }

    const muteStatus = callStatus.muteStatus ? 1 : 0;
    this.sendToDevice(1 | (muteStatus << 1));
    callStatus.holdStatus = false;
    console.log(`"${deviceActive?.productName}" resume`);
    return true;
  },

  setActiveDevice(id) {
    console.log(`setActiveDevice - searching for deviceId: ${id}, allDevices.length: ${allDevices.length}`); //eslint-disable-line
    for (let i = 0; i < allDevices.length; i += 1) {
      const dev = allDevices[i];
      console.log(`setActiveDevice - checking device ${i}: deviceId=${dev.deviceId}, productName=${dev.productName}`); //eslint-disable-line
      if (dev.deviceId === id) {
        deviceActive = dev;
        console.log(`setActiveDevice - device found and set as active:`, dev.productName); //eslint-disable-line
        console.log(`setActiveDevice - device.device.oninputreport type:`, typeof deviceActive.device.oninputreport); //eslint-disable-line
        console.log(`setActiveDevice - device.device.oninputreport:`, deviceActive.device.oninputreport); //eslint-disable-line
        // Open device asynchronously to avoid blocking
        this.openDevice().catch((error) => {
          console.error('Failed to open active device:', error);
        });
        break;
      }
    }
    if (!deviceActive || deviceActive.deviceId !== id) {
      console.error(`setActiveDevice - deviceId ${id} not found in allDevices`); //eslint-disable-line
    }
  },

  async requestDevice() {
    const filters = [{
      usage: 0x0005,
      usagePage: 0x000B,
      vendorId: 0x6993,
    }];

    const devices = await navigator.hid.requestDevice({ filters });
    let dev;
    devices.forEach((device) => {
      console.log('add HID device.', device);
      dev = device;
    });

    if (!dev) return null;

    if (dev.opened) {
      console.log('device already exist.');
      return null;
    }

    addDevice(dev);

    return {
      productName: dev.productName,
      vid: dev.vendorId,
      pid: dev.productId,
    };
  },

  addCallDevice(deviceId, vid, pid) {
    for (let i = 0; i < allDevices.length; i += 1) {
      const dev = allDevices[i];
      if (vid === dev.device.vendorId && pid === dev.device.productId && dev.deviceId === '0') {
        allDevices[i].deviceId = deviceId;
        console.log('add one call device', dev);
      }
    }
  },

  sendToDevice(value) {
    if (!deviceActive) return;
    deviceActive.sendReport(new Uint8Array([value]));
  },

  async openDevice() {
    console.log('openDevice - called');
    if (!deviceActive) {
      console.log('openDevice - no select device');
      return false;
    }
    console.log('openDevice - deviceActive:', deviceActive.productName, 'opened:', deviceActive.device.opened);
    if (deviceActive.device.opened) {
      console.log('openDevice - device already opened, returning true');
      return true;
    }

    // Check if another device is already being opened
    if (deviceOpening) {
      console.log('openDevice - another device is currently being opened, waiting...');
      await new Promise((resolve) => {
        setTimeout(resolve, 200);
      });
      console.log('openDevice - wait complete, device opened:', deviceActive.device.opened);
      return deviceActive.device.opened;
    }

    deviceOpening = true;
    try {
      console.log('openDevice - calling deviceActive.open()');
      await deviceActive.open();
      console.log('openDevice - device opened successfully, opened status:', deviceActive.device.opened);
      console.log('Waiting for user to press "rumble" button...');
      return deviceActive.device.opened;
    } catch (error) {
      if (error.name === 'InvalidStateError') {
        console.log('openDevice - InvalidStateError, device already being opened:', error.message);
        // Wait a moment and check if it's now opened
        await new Promise((resolve) => {
          setTimeout(resolve, 100);
        });
        console.log('openDevice - after wait, device opened:', deviceActive.device.opened);
        return deviceActive.device.opened;
      }
      console.error('openDevice - failed to open device:', error);
      return false;
    } finally {
      deviceOpening = false;
    }
  },

  // Getters for integration
  getAllDevices: () => allDevices,
  getActiveDevice: () => deviceActive,
  getCallStatus: () => ({ ...callStatus }),
  updateCallStatus: (status) => {
    callStatus = { ...callStatus, ...status };
  },
};

// HID event handlers
navigator.hid.onconnect = async (event) => {
  console.log('[YealinkSDK onconnect] Event received:', event.device?.productName, 'vendorId:', event.device?.vendorId);
  if (event.device.productName === 'HID debug interface') return;
  // Only handle Yealink devices (vendorId 0x6993 = 27027)
  if (event.device.vendorId !== 0x6993) {
    console.log('[YealinkSDK onconnect] Not a Yealink device, skipping');
    return;
  }

  console.log('[YealinkSDK onconnect] Yealink device detected:', event.device.productName);
  console.log('[YealinkSDK onconnect] Collections:', event.device.collections?.length, event.device.collections);
  console.log('[YealinkSDK onconnect] Current allDevices count:', allDevices.length);

  // Check if device is already in allDevices
  const alreadyAdded = allDevices.some((dev) => dev.device === event.device);
  if (alreadyAdded) {
    console.log('[YealinkSDK onconnect] Device already added, skipping:', event.device.productName);
    return;
  }

  // Add device directly - don't skip based on collections.length
  console.log('[YealinkSDK onconnect] Calling addDevice for:', event.device.productName);
  addDevice(event.device);
  console.log('[YealinkSDK onconnect] After addDevice, allDevices count:', allDevices.length);
};

navigator.hid.ondisconnect = (event) => {
  if (event.device.productName === 'HID debug interface') return;
  // Only handle Yealink devices (vendorId 0x6993 = 27027)
  if (event.device.vendorId !== 0x6993) return;

  for (let i = 0; i < allDevices.length; i += 1) {
    if (event.device === allDevices[i].device) {
      window.postMessage({
        direction: 'yealink-headset-extension-from-web-hid',
        Msg: 'deviceDisconnect',
        deviceId: allDevices[i].deviceId,
      });

      console.log('hid disconnected: ', allDevices[i]);
      allDevices.splice(i, 1);
      break;
    }
  }
};
